export default __webpack_public_path__ + "static/media/searchRed.90515ae1.svg";